import { render } from "./InstgramReelReview.vue?vue&type=template&id=099787f8&scoped=true"
import script from "./InstgramReelReview.vue?vue&type=script&lang=js"
export * from "./InstgramReelReview.vue?vue&type=script&lang=js"

import "./InstgramReelReview.vue?vue&type=style&index=0&id=099787f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099787f8"]])

export default __exports__